import React from 'react'
import gql from 'graphql-tag'
import { SpinnerButton } from '@/components/common/button'
import { useMarkChatAsProcessedMutation } from './__gen/process-button'

gql`
	mutation markChatAsProcessed($id: ID!, $processedAt: DateTime) {
		llmChatAdmin_Update(input: { id: $id, processedAt: $processedAt }) {
			object {
				id
				processedAt
			}
		}
	}
`

type Props = {
	id: string
	processedAt: string | null
}

export const ProcessButton = ({ id, processedAt }: Props) => {
	const [mutate, { loading, error }] = useMarkChatAsProcessedMutation({
		variables: { id, processedAt: !processedAt ? new Date().toISOString() : null },
	})

	if (error) {
		return <p>Error: {error.message}</p>
	}

	return (
		<SpinnerButton disabled={loading} loading={loading} onClick={() => mutate()}>
			{processedAt ? 'Unset' : 'Set'}
		</SpinnerButton>
	)
}
